module.exports = __webpack_public_path__ + "static/media/cricket-ball.7e06a9ec.png";